import CompaniesCustomers from './CompaniesCustomers';

export default CompaniesCustomers;
